import React, { useState } from 'react';
import './Cookies.scss';
import './Cookies-media.scss';
import Button from '../Button/Button';
import {content} from "../../services/content";
import {EnumUrlsPages} from "../../services/Enum";

const Cookies = () => {
  const hasAccept = localStorage.getItem('cookiesDalli');
  const [show, setShow] = useState<boolean>(!hasAccept);

  const acceptCookies = () => {
    setShow(false);
    localStorage.setItem('cookiesDalli', 'true');
  };

  return show ? (
    <div className="cookies">
      <p>
        Продолжая использовать сайт, Вы даете согласие ООО «ДАЛЛИ-CЕРВИС» (ИНН7736662574) на обработку файлов cookies и пользовательских данных,
        собираемых посредством агрегаторов статистики посетителей веб-сайтов «Яндекс.Метрика», «Top.Mail.ru» в целях ведения статистики и аналитики посещений сайта в соответствии с <a href={EnumUrlsPages.policy} target="_blank" style={{textDecoration: 'underline'}} rel="noopener noreferrer">политикой конфиденциальности</a>.
      </p>
      <Button text={"Согласен(-а)"} size="M" onClick={acceptCookies} />
    </div>
  ) : null;
};

export default Cookies;
